export const FETCH_PATIENT_REVIEW_REQUEST = "FETCH_PATIENT_REVIEW_REQUEST";
export const FETCH_PATIENT_REVIEW_SUCCESS = "FETCH_PATIENT_REVIEW_SUCCESS";
export const FETCH_PATIENT_REVIEW_FAILURE = "FETCH_PATIENT_REVIEW_FAILURE";